export default __webpack_public_path__ + "static/media/lighthouse.ec4b188e.jpg";